import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { recordReactRender } from './runtimePerformance';
import { recordRuntimeSessionEvent } from '../diagnostics/runtimeSessionRecorder';

export default function FoundationPerformanceProfiler({ children }) {
  const onRender = useCallback((id, phase, actualDuration, baseDuration, startTime, commitTime) => { recordReactRender({ component: id, phase, actualDuration, baseDuration, startTime, commitTime, reason: phase === 'mount' ? 'initial mount' : 'application state or context update' }); recordRuntimeSessionEvent('react', 'COMMIT', { component: id, phase, actualDuration, baseDuration, startTime, commitTime }); }, []);
  return <React.Profiler id="Application" onRender={onRender}>{children}</React.Profiler>;
}
FoundationPerformanceProfiler.propTypes = { children: PropTypes.node };
FoundationPerformanceProfiler.defaultProps = { children: null };
